export default __webpack_public_path__ + "static/media/no-data.57502814.svg";